import SymbolWinResult from "slotworks/model/gameplay/records/results/symbol-win-result";

export default class FreespinScatterResult extends SymbolWinResult {
}
